import React from 'react';
import qs from 'query-string';
import BookingService from '../../services/bookingService';

/**
 * The following HOC is used to inject the "bookingSettings" object in to _app.js, do not use else where!
 */
export const withBookingSettings = (App, helpers) =>
  class BookingSettings extends React.Component<any, any> {
    static displayName = 'BookingSettings';

    constructor(props) {
      super(props);
      this.state = {
        bookingSettings: null,
      };
    }

    componentDidMount() {
      const { http } = helpers;
      const { bookingSettings } = this.state;
      const { salonId } = qs.parse(window.location.search) as any;

      // Server side did not result data
      if (!bookingSettings && salonId) {
        BookingService(http).fetchSettings(salonId)
          .then(settings => this.setState({ bookingSettings: settings }))
          .catch(() => this.setState({ bookingSettings: {} }));
      }
    }

    render() {
      const { bookingSettings } = this.state;
      return <App {...this.props} bookingSettings={bookingSettings} />;
    }
  };
